export default __webpack_public_path__ + "static/Gop_stop-8e0e93e049ec3b3785c2302ac4801ed9.png";